const genderMap = {
  0: "女性",
  1: "男性",
};

const birthTimeMap = {
  0: "早子時 00:00-00:59",
  1: "丑時 01:00-03:00",
  2: "寅時 03:00-05:00",
  3: "卯時 05:00-07:00",
  4: "辰時 07:00-09:00",
  5: "巳時 09:00-11:00",
  6: "午時 11:00-13:00",
  7: "未時 13:00-15:00",
  8: "申時 15:00-17:00",
  9: "酉時 17:00-19:00",
  10: "戌時 19:00-21:00",
  11: "亥時 21:00-23:00",
  12: "晚子時 23:00-23:59",
};

const loveStatusMap = {
  0: "尚未交往",
  1: "交往中",
};

const emotionStatusMap = {
  0: "未婚無伴",
  1: "未婚有伴",
  2: "已婚",
};

const identityStatusMap = {
  0: "學生",
  1: "上班族",
  2: "自由工作者",
  3: "創業家／企業家",
  4: "家庭主婦／夫",
  5: "其它",
};

const anaTabsMap = {
  0: "個性",
  1: "事業",
  2: "財運",
  3: "感情",
  4: "健康",
  5: "家庭",
  6: "人際",
};

module.exports = {
  genderMap,
  birthTimeMap,
  anaTabsMap,
  loveStatusMap,
  emotionStatusMap,
  identityStatusMap,
};
